import { ThreeSixtyInvestigatingRow } from "../api/ThreeSixty";
import { GenericObject } from "./FilterSortHeader";
import { usePermissionValidator } from "../api/UserPermissionValidators";
import { ThreeSixtyRowRendererBase } from "./ThreeSixtyRowRendererBase";
import { ThreeSixtyAssignedToCell } from "./ThreeSixtyAssignedToCell";

type ThreeSixtyInvestigatingRowProps = {
  row: ThreeSixtyInvestigatingRow | GenericObject;
  cancel: string[];
  toggleCancel: (value: string) => number;
  forceReload: () => void;
};

export const ThreeSixtyInvestigatingRowRenderer = (
  props: ThreeSixtyInvestigatingRowProps
) => {
  const { row, cancel, toggleCancel, forceReload } = props;
  const perms = usePermissionValidator();

  return (
    <ThreeSixtyRowRendererBase
      row={row}
      cancel={cancel}
      toggleCancel={toggleCancel}
      linkPath="/workbench"
      canShowLink={perms.canViewWIP360Reports || perms.canEdit360Reports}
      afterDueDateColumns={
        <ThreeSixtyAssignedToCell
          workflowRunUuid={row.workflow_run_uuid}
          lockedBy={row.locked_by}
          onRefresh={forceReload}
        />
      }
    />
  );
};
